import { RootState } from 'store/root-reducer';

export const getTrucksTransits = (state: RootState) => state.statistics.trucksTransits;
